module.exports = import("angular").then(angular => {
    var app = angular.module("tapCache", []);

    app.factory("cache", function() {
        var cache = {};

        return {
            get: function(key) {
                if (cache[key] && (!cache[key].validTo || new Date() < cache[key].validTo)) {
                    return Object.assign({}, cache[key].value);
                }
            },
            set: function(key, value, validTo) {
                cache[key] = {
                    value: Object.assign({}, value),
                };

                if (validTo instanceof Date) {
                    cache[key].validTo = validTo;
                }
            },
            invalidate: function(key) {
                delete cache[key];
            },
            invalidateAll: function() {
                cache = {};
            },
        };
    });
});
